export enum LayoutVariant {
  CIRCLED = 'CIRCLED',
  SQUARE = 'SQUARE'
}

export default LayoutVariant;
